__turbopack_context__.v({
  "toggle": "FilterToggle-module-scss-module__XVweaG__toggle",
  "toggleContainer": "FilterToggle-module-scss-module__XVweaG__toggleContainer",
});
